import { selectors as requestSelectors } from "redux-request-state";

const smsStatisticsBase = state => state.marketplace.product.smsStatistics;
export const getSmsStatistics = requestSelectors.getData( smsStatisticsBase );
export const isLoadingSmsStatistics = requestSelectors.isLoading( smsStatisticsBase );
